import { useState, useEffect, useCallback } from 'react';
import { generateDeviceFingerprint, getViewIdFromURL } from '../utils/DeviceFingerprintGenerator';
import { registerDevice, getViewForDevice } from '../services/Api';

export const useDeviceManager = () => {
  const [fingerprint, setFingerprint] = useState(null);
  const [viewName, setViewName] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const initializeDevice = useCallback(async () => {
    try {
      setLoading(true);
      setError(null);

      const viewId = getViewIdFromURL();
      const fp = generateDeviceFingerprint(viewId);
      setFingerprint(fp);
      await registerDevice(fp, {
        viewId,
        url: window.location.href,
        userAgent: navigator.userAgent,
        timestamp: new Date().toISOString()
      });

      const viewData = await getViewForDevice(fp);
      setViewName(viewData.viewName || 'default');

    } catch (err) {
      console.error('Device initialization error:', err);
      setError(err.message);
      setViewName('error');
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    const timer = setTimeout(initializeDevice, 100);
    return () => clearTimeout(timer);
  }, [initializeDevice]);

  const refreshView = useCallback(async () => {
    if (!fingerprint) return;

    try {
      const viewData = await getViewForDevice(fingerprint);
      setViewName(viewData.viewName || 'default');
    } catch (err) {
      console.error('Error refreshing view:', err);
      setError(err.message);
    }
  }, [fingerprint]);

  return {
    fingerprint,
    viewName,
    loading,
    error,
    refreshView,
    viewId: getViewIdFromURL()
  };
};